<template>
    <div id="ii-label-edit">
        <div class="box">
            <div class="content">
                <component :is="label.getObjectType()+'_component'" :label="label"></component>
                <Link_Small :baseObject="label" :storyId="label.getStoryId()"/>
            </div>
        </div>
    </div>
</template>

<script>
import hotspot_component from "@/modules/labels/Hotspots_Edit";
import overlay_component from "@/modules/labels/Overlays_Edit";
import xrayspot_component from "@/modules/labels/XRays_Edit";
import text_component from "@/modules/labels/Texts_Edit";
import area_component from "@/modules/labels/Areas_Edit";
import marker_component from "@/modules/labels/Markers_Edit";
import Btn from "@/modules/buttons/btn";
import Link_Small from "@/modules/links/Link_Small";
import {label} from "@/class/label";

export default {
    name: "InteractiveImage_Label_Edit",
    components: {
        hotspot_component,overlay_component, xrayspot_component, text_component, area_component, marker_component, Btn,Link_Small
    },
    props:{
        label:{type:Object,default:() => new label()},
    },
    methods: {
        close(){
            this.label.unedit();
        },
        save() {
            this.label.save();
    
            this.label.unedit();
        },
        cancel() {
            // if (!this.label.hasChange()) {
            //     this.label.unedit();
            //     return;
            // }
            return this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('Confirm'),
                text: this.$t("Do you really want to cancel the changes ?"),
                acceptText:this.$t('Yes, cancel the changes'),
                cancelText:this.$t('No'),
                accept: this.cancelConfirm
            })
        },
        cancelConfirm() {
            if (this.label.isNew()) {
                return this.label.unedit();
            }
            // this.label.restore();
            this.label.save();
    
            this.label.unedit();
        }
    },
    watch:{
        'label.pk'(){
        
        }
    },
    mounted() {
        console.log(this.label.getObjectType())
    }
}
</script>
